export const setHeightUnit = unit => ({
  type: 'SET_HEIGHT_UNIT',
  payload: unit,
});
